<template>
    <transition name="fade">
        <div class="Modal" style="z-index:99999" id="ForgotPasswordModal" v-on:keyup.esc="close" role="dialog" aria-modal="true" aria-labelledby="dialogtitle">
            <div class="Modal__Window">
                <button class="Modal__Close Button__Link" type="button" v-on:click.prevent="close">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" height="23" width="23" role="img">
                        <title>{{$t('forgotPassword.closeWindow')}}</title>
                        <circle cx="26" cy="26" r="26" fill="#595959" />
                        <path fill="none" stroke="#FFFFFF" stroke-width="4" stroke-miterlimit="10" d="M12.6 12.6L39.4 39.4M39.4 12.6L12.6 39.4" stroke-linecap="round"
                              stroke-linejoin="round" />
                    </svg>
                </button>

                <div class="Panels">
                    <transition name="fade-slide">
                        <div class="Panels__Item" v-if="panel == 'reset' || panel == ''" key="reset">
                            <h2 id="dialogtitle">{{ $t('forgotPassword.title') }}</h2>

                            <div class="u-marginTop5">
                                <p>
                                    {{ $t('forgotPassword.intro') }}
                                </p>
                            </div>

                            <div class="u-marginTop4">
                                <label class="u-visuallyhidden" for="emails" aria-hidden="true">{{$t('forgotPassword.emailField')}}</label>
                                <input class="Input" id="email" type="email" :placeholder="$t('forgotPassword.emailField')" @keypress.enter.prevent="triggerPassword" v-model="emails" />
                            </div>

                            <div class="u-marginTop2 u-xs-marginTop1" aria-live="assertive">
                                <transition name="fade">
                                    <span class="Validation__Error" v-html="ValidationMessage" v-if="!IsValidData"></span>
                                    <span class="Validation__PleaseWait" v-else-if="isLoading">{{$t('forgotPassword.PleaseWait')}}</span>
                                </transition>
                            </div>

                            <div class="u-marginTop2" v-if="!isLoading">
                                <button class="Button Button--fullWidth" type="button" :disabled="v$.formPassword.$invalid" ref="passwordBtn" @click.prevent="submitPassword">
                                    <span class="span-wrapper">{{ $t('forgotPassword.submit') }}</span>
                                </button>
                            </div>

                            <div class="u-marginTop3 u-textCenter" v-if="!isLoading">
                                <button class="Button__Link u-font700" v-on:click.prevent="close">
                                    <span class="span-wrapper">{{$t('forgotPassword.cancelBtn')}}</span>
                                </button>
                            </div>
                        </div>

                        <div class="Panels__Item" v-else-if="panel == 'SecurityCode'" key="SecurityCode">
                            <h2 id="dialogtitle" v-if="!codeLimitExceeded">{{ $t('forgotPassword.title4') }}</h2>
                            <h2 id="dialogtitle" v-else>{{ $t('forgotPassword.titleCodeExceeded') }}</h2>

                            <div class="u-marginTop5">
                                <p v-html="$t('forgotPassword.intro4')"></p>
                            </div>

                            <div class="u-marginTop4">
                                <label class="Label u-visuallyhidden" for="codeInput">{{ $t('forgotPassword.codeField') }}</label>
                                <input class="Input" id="codeInput" type="text" :placeholder="$t('forgotPassword.codeField')" @keypress.enter.prevent="triggerCode" v-model="securityCode" />
                            </div>

                            <div class="u-marginTop2 u-xs-marginTop1" aria-live="assertive">
                                <transition name="fade">
                                    <span class="Validation__Error" v-html="ValidationMessage" v-if="!IsValidData"></span>
                                    <span class="Validation__Success" v-html="ResendMessage" v-else-if="IsResendCode"></span>
                                    <span class="Validation__PleaseWait" v-else-if="isLoading">{{ $t('forgotPassword.PleaseWait') }}</span>
                                </transition>
                            </div>

                            <div class="u-marginTop1 u-textRight" v-if="!isLoading">
                                <button class="Button__Link u-font300" v-on:click.prevent="resendCode" v-if="!codeLimitExceeded" :disabled="timer > 0">
                                    <span class="span-wrapper">{{$t('forgotPassword.resendBtn')}}</span> 
                                    <span style="margin-left: 5px;" v-if="timer !== 0">({{timer}} sec)</span>
                                </button>
                            </div>

                            <div class="u-marginTop2" v-if="!isLoading">
                                <button class="Button Button--fullWidth" type="submit" v-if="!codeLimitExceeded" :disabled="v$.formSecurityCode.$invalid" ref="securityCodeBtn" @click.prevent="verifyCode">
                                    <span class="span-wrapper">{{ $t('forgotPassword.submit') }}</span>
                                </button>
                            </div>

                            <div class="u-marginTop3 u-textCenter" v-if="!isLoading">
                                <button class="Button__Link u-font700" v-on:click.prevent="close">
                                    <span class="span-wrapper">{{$t('forgotPassword.cancelBtn')}}</span>
                                </button>
                            </div>
                        </div>

                        <div class="Panels__Item" v-else-if="panel == 'security'" key="security">
                            <h2 id="dialogtitle">{{ $t('forgotPassword.titile2') }}</h2>

                            <div class="u-marginTop5">
                                <p>
                                    {{ $t('forgotPassword.intro2') }}
                                </p>
                            </div>

                            <div class="u-marginTop4">
                                <label class="Label" for="security">{{ securityQuestion }}</label>
                                <input class="Input" id="security" type="text" :placeholder="$t('forgotPassword.ansField')" @keypress.enter.prevent="triggerSecurity" v-model="security" />
                            </div>

                            <div class="u-marginTop2 u-xs-marginTop1" aria-live="assertive">
                                <transition name="fade">
                                    <span class="Validation__Error" v-html="ReturnMessage" v-if="!IsValidData"></span>
                                    <span class="Validation__PleaseWait" v-else-if="isLoading">{{ $t('forgotPassword.PleaseWait') }}</span>
                                </transition>
                            </div>

                            <div class="u-marginTop2" v-if="!isLoading && !QuestionModel.MaxTry">
                                <button class="Button Button--fullWidth" type="submit" :disabled="v$.formSecurity.$invalid" ref="securityBtn" @click.prevent="submitSecurity">
                                    <span class="span-wrapper">{{ $t('forgotPassword.submit') }}</span>
                                </button>
                            </div>

                            <div class="u-marginTop3 u-textCenter" v-if="!isLoading">
                                <button class="Button__Link u-font700" v-on:click.prevent="close">
                                    <span class="span-wrapper">{{$t('forgotPassword.cancelBtn')}}</span>
                                </button>
                            </div>
                        </div>

                        <div class="Panels__Item u-textCenter" v-else-if="panel == 'complete'" key="complete">
                            <i class="Icon Icon__complete-thumbsup u-fontSize4"></i>
                            <h2 id="dialogtitle">{{$t('forgotPassword.title3')}}</h2>
                            <div class="u-marginTop3">
                                <p>
                                    {{ $t('forgotPassword.intro3') }}
                                </p>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    // Importing Packages
    import { ref, onMounted, computed, nextTick, emits } from 'vue';
    import { useVuelidate } from '@vuelidate/core';
    import { required, email } from '@vuelidate/validators';
    import axios from 'axios';

    // Importing Components
    import FullLoader from './FullLoader.vue'

    export default {
        emits: ['close-modal'],
        props: ['view'],
        components: {
            FullLoader
        },
        setup(props, {emit}) {
            onMounted(() => {
                nextTick(() => {
                    modalOpen('ForgotPasswordModal');
                })

                setInterval(() => {
                    countdownTimer();
                }, 1000);
            })

            // Data
            const IsValidData = ref(true);
            const IsResendCode = ref(false);
            const ValidationMessage = ref('');
            const ResendMessage = ref('');
            const ReturnMessage = ref('');
            const QuestionModel = ref({});
            const securityQuestion = ref('');
            const panel = ref('');
            const emails = ref('');
            const security = ref('');
            const securityCode = ref('');
            const label = ref('');
            const overlay = ref(true);
            const passwordBtn = ref(null);
            const securityBtn = ref(null);
            const securityCodeBtn = ref(null);
            const isLoading = ref(false);
            const codeLimitExceeded = ref(false);
            const resetCodeTime = 30;
            const timer = ref(resetCodeTime);
            

            // Validations
            const rules = computed(() => ({

                formPassword: {
                    emails: { required, email }
                },
                formSecurity: {
                    security: { required }
                },
                formSecurityCode: {
                    securityCode: { required }
                }
            }))

            const v$ = useVuelidate(rules, { formPassword: { emails }, formSecurity: { security }, formSecurityCode: { securityCode } });

            // Methods
            const close = () => {
                emit('close-modal')
            };

            const triggerPassword = () => {
                passwordBtn.value.click();
            };

            const triggerSecurity = () => {
                securityBtn.value.click();
            };

            const triggerCode = () => {
                securityCodeBtn.value.click();
            }

            const countdownTimer = () => {
                if (panel.value !== 'SecurityCode' || timer.value == 0) {
                    return;
                }

                timer.value = timer.value - 1;
            }

            const submitPassword = () => {
                try {
                    //clear the errors:
                    IsValidData.value = true;
                    ValidationMessage.value = '';
                    IsResendCode.value = false;
                    ResendMessage.value = '';
                    isLoading.value = true;

                    var url = '/Account/ForgotPassword/';
                    var qs = require('qs');
                    var data = {
                        "EmailAddress": emails.value
                    };

                    var qs = require('qs');
                    let token = document.getElementsByName('__RequestVerificationToken')[0].value;
                    var thetoken = "__RequestVerificationToken=" + token + '&';
                    var str = qs.stringify(data);
                    axios.post(url, thetoken + str)
                        .then((response) => {
                            if (response.data.ResponseCode === 64) {
                                panel.value = 'SecurityCode';
                            }
                            else {
                                IsValidData.value = false;
                                ValidationMessage.value = response.data.ValidationMessage;
                            }
                            isLoading.value = false;
                        })
                        .catch((error) => {
                            isLoading.value = false;
                        });
                } catch (ex) {
                    isLoading.value = false;
                }
                modalOpen('ForgotPasswordModal')
            };

            const verifyCode = () => {
                try {
                    //clear the errors:
                    IsValidData.value = true;
                    ValidationMessage.value = '';
                    IsResendCode.value = false;
                    ResendMessage.value = '';
                    isLoading.value = true;

                    var url = '/Account/VerifySecurityCode/';

                    var data = securityCode.value;
                    var data = {
                        "EmailAddress": emails.value,
                        "SecurityCode": securityCode.value
                    };

                    var qs = require('qs');
                    let token = document.getElementsByName('__RequestVerificationToken')[0].value;
                    var thetoken = "__RequestVerificationToken=" + token + '&';
                    var str = qs.stringify(data);

                    axios.post(url, thetoken + str)
                        .then((response) => {
                            if (response.data.ResponseCode === 64) {
                                securityQuestion.value = response.data.QuestionModel.QuestionDetails;
                                QuestionModel.value = response.data.QuestionModel;
                                panel.value = 'security';
                            }
                            else {
                                IsValidData.value = false;
                                ValidationMessage.value = response.data.ValidationMessage;
                                QuestionModel.value = response.data.QuestionModel;
                                securityCode.value = '';
                            }
                            isLoading.value = false;
                        })
                        .catch((error) => {
                            isLoading.value = false;
                        });
                } catch (ex) {
                    isLoading.value = false;
                }
                modalOpen('ForgotPasswordModal')
            };

            const submitSecurity = () => {
                try {
                    //clear the errors:
                    IsValidData.value = true;
                    ValidationMessage.value = '';
                    IsResendCode.value = false;
                    ResendMessage.value = '';
                    isLoading.value = true;

                    var url = '/Account/VerifySecurityQuestion/';

                    QuestionModel.value.QuestionAnswer = security.value;

                    var data = QuestionModel.value;
                    
                    var qs = require('qs');
                    let token = document.getElementsByName('__RequestVerificationToken')[0].value;
                    var thetoken = "__RequestVerificationToken=" + token + '&';
                    var str = qs.stringify(data);
                    axios.post(url, thetoken + str)
                        .then((response) => {
                            if (response.data.ResponseCode === 64) {
                                IsValidData.value = true;
                                securityQuestion.value = response.data.QuestionModel.QuestionDetails;
                                QuestionModel.value = response.data.QuestionModel;
                                panel.value = 'complete';
                            }
                            else {
                                IsValidData.value = false;
                                securityQuestion.value = response.data.QuestionModel.QuestionDetails;
                                ReturnMessage.value = response.data.ReturnMsg;
                                QuestionModel.value = response.data.QuestionModel;
                                security.value = '';
                            }

                            isLoading.value = false;
                        })
                        .catch((error) => {
                            isLoading.value = false;
                        });
                } catch (ex) {
                    isLoading.value = false;
                }
                modalOpen('ForgotPasswordModal')
            };

            const resendCode = () => {
                try {
                    //clear the errors:
                    IsValidData.value = true;
                    ValidationMessage.value = '';
                    ResendMessage.value = '';
                    IsResendCode.value = false;
                    ResendMessage.value = '';
                    isLoading.value = true;
                    codeLimitExceeded.value = false;

                    var url = '/Account/ForgotPassword/';
                    var qs = require('qs');
                    var data = {
                        "EmailAddress": emails.value,
                        "ResendCode": true
                    };

                    var qs = require('qs');
                    let token = document.getElementsByName('__RequestVerificationToken')[0].value;
                    var thetoken = "__RequestVerificationToken=" + token + '&';
                    var str = qs.stringify(data);

                    axios.post(url, thetoken + str)
                        .then((response) => {
                            if (response.data.ResponseCode === 64) {
                                IsResendCode.value = true;
                                ResendMessage.value = response.data.ValidationMessage;
                                timer.value = resetCodeTime;
                            }
                            else {
                                IsValidData.value = false;
                                IsResendCode.value = false;
                                ValidationMessage.value = response.data.ValidationMessage;
                                codeLimitExceeded.value = true;
                            }
                            isLoading.value = false;
                        })
                        .catch((error) => {
                            timer.value = resetCodeTime;
                            isLoading.value = false;
                        });
                } catch (ex) {
                    timer.value = resetCodeTime;
                    isLoading.value = false;
                }
                modalOpen('ForgotPasswordModal')
            }

            return {
                v$,
                IsValidData,
                IsResendCode,
                ValidationMessage,
                ResendMessage,
                ReturnMessage,
                QuestionModel,
                securityQuestion,
                panel,
                emails,
                security,
                securityCode,
                isLoading,
                label,
                overlay,
                close,
                triggerPassword,
                triggerSecurity,
                submitPassword,
                submitSecurity,
                verifyCode,
                resendCode,
                timer,
                passwordBtn,
                securityBtn,
                securityCodeBtn,
                codeLimitExceeded
            }  
        }
    };
</script>